import { render, staticRenderFns } from "./StudentExaminationPointRemake.vue?vue&type=template&id=6f63baea&"
import script from "./StudentExaminationPointRemake.vue?vue&type=script&lang=js&"
export * from "./StudentExaminationPointRemake.vue?vue&type=script&lang=js&"
import style0 from "./StudentExaminationPointRemake.vue?vue&type=style&index=0&id=6f63baea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports